/** *********************************************
  Reducer is responsible for handling auth data.
********************************************** */
import createReducer from '../utils/createReducer';
import actionTypes from '../actions/auth/actionTypes';


const initialState = {
  auth: false,
  userId: null,
  loginRequest: false,
  loginError: null,
  restorePasswordRequest: false,
  restorePasswordError: null,
  resetPasswordRequest: false,
  resetPasswordError: null,
  isEulaAccepted: null
};

const loginRequest = (state, action) => ({
  ...state,
  loginRequest: true,
});

const loginSuccess = (state, action) => ({
  ...state,
  auth: true,
  loginRequest: false,
  loginError: null,
  eula: action.eula,
  userId: action.userId,
});

const loginFailure = (state, action) => ({
  ...state,
  loginRequest: false,
  loginError: action.errorMessage
});

const restorePasswordRequest = (state, action) => ({
  ...state,
  restorePasswordRequest: true
});

const restorePasswordSuccess = (state, action) => ({
  ...state,
  restorePasswordRequest: false,
  restorePasswordError: null
});

const restorePasswordFailure = (state, action) => ({
  ...state,
  restorePasswordRequest: false,
  restorePasswordError: action.errorMessage
});

const resetPasswordRequest = (state, action) => ({
  ...state,
  resetPasswordRequest: true
});

const resetPasswordSuccess = (state, action) => ({
  ...state,
  resetPasswordRequest: false,
  resetPasswordError: null
});

const resetPasswordFailure = (state, action) => ({
  ...state,
  resetPasswordRequest: false,
  resetPasswordError: action.errorMessage
});

const logOut = (state) => ({
  ...state,
  auth: false,
  eula: null,
  userId: null,
});

const clearAuthErrors = (state) => ({
  ...state,
  loginError: null,
  restorePasswordError: null
});

const acceptEulaSuccess = (state) => {
  return {
    ...state,
    eula: true,
  }
};

const fetchAccountStatusSuccess = (state, action) => {
  return {
    ...state,
    eula: action.eula,
  }
};

export default createReducer(initialState, {
  [actionTypes.LOGIN_REQUEST]: loginRequest,
  [actionTypes.LOGIN_SUCCESS]: loginSuccess,
  [actionTypes.LOGIN_FAILURE]: loginFailure,
  [actionTypes.RESTORE_PASSWORD_REQUEST]: restorePasswordRequest,
  [actionTypes.RESTORE_PASSWORD_FAILURE]: restorePasswordFailure,
  [actionTypes.RESTORE_PASSWORD_SUCCESS]: restorePasswordSuccess,
  [actionTypes.RESET_PASSWORD_REQUEST]: resetPasswordRequest,
  [actionTypes.RESET_PASSWORD_FAILURE]: resetPasswordFailure,
  [actionTypes.RESET_PASSWORD_SUCCESS]: resetPasswordSuccess,
  [actionTypes.LOGOUT]: logOut,
  [actionTypes.CLEAR_AUTH_ERRORS]: clearAuthErrors,
  [actionTypes.ACCEPT_EULA_SUCCESS]: acceptEulaSuccess,
  [actionTypes.FETCH_ACCOUNT_STATUS_SUCCESS]: fetchAccountStatusSuccess,
});



// WEBPACK FOOTER //
// src/reducers/auth.js